import { Loading } from "element-ui";

let loading: { close: () => void };
function openLoading() {
  loading = Loading.service({
    lock: true,
    text: "正在加载...",
    spinner: "",
    background: "rgba(0, 0, 0, 0.3)",
    body: true
  });

  setTimeout(function() { // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
    loading.close(); // 关闭遮罩层
  }, 5000);
}
// 结束
function closeLoading() {
  loading.close();
}

export { openLoading, closeLoading };
